<template>
  <section class="d-flex align-items-center" id="wrap">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <clip-loader :margin="margin" :color="color" :size="size" :loading="loading"></clip-loader>
          <h2>LOADING DATA FROM YOUR ID CARD</h2>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {hub} from '../assets/js/iSCertHub';

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: "WaitForData",
  data () {
    return {
      color: '#3c3c3c',
      size: '80px',
      margin: '2px',
      loading: true

    }
  },
  components: {
    ClipLoader
  },
  mounted() {
    let value = {"operation": "ALL"}
    let param = JSON.stringify(value)
    console.log("{}")
    console.log(param);
    console.log(hub)
    hub.caller("nid-reader")
        .value(param)
        .onFail(() =>{
          alert("Error connecting to middleware. Are you sure it is installed?");
        })
        .call((obj) =>{
          console.log(obj)
          if(obj.success===true){
            this.$emit('nextStep','StepTwo')
            this.$emit('data',obj.data.personInformation)
          }else{
            this.$emit('data',obj)
            this.$emit('nextStep','StepError')
          }
        });

  },
  emits: ['nextStep','data'],
  props:{
    data: {}
  },

}
</script>

<style scoped>

</style>